export { default } from './FormLabel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/FormLabel/index.js
// module id = 545
// module chunks = 2